// extracted by mini-css-extract-plugin
export var callCard = "_ij-0";
export var callMessageButton = "_ij-1";
export var helpIcon = "_ij-3";
export var helpIconContainer = "_ij-4";
export var verticalDivider = "_ij-2";